const locales = {
  retry: "Újrapróbálás",
  abrasion_dimension: "Kopó méret",
  add: "Hozzáadás",
  address: "Cím",
  add_alert: "Riasztás hozzáadása",
  add_site: "Munkavégzési hely hozzáadása",
  add_contact: "Kontakt hozzáadása",
  alert_date: "Riasztás dátuma",
  alert_handled_date: "Lekezelés dátuma",
  alerts: "Szervíz riasztások",
  alert_state_new: "Új",
  alert_state_triggered: "Lejárt",
  alert_state_handled: "Lekezelt",
  all: "Összes",
  amount: "Mennyiség",
  amount_type: "Mennyiség egység",
  amountType_abrasionMm: "Kopás mm",
  amountType_daily: "Napi",
  amountType_monthly: "Havi",
  amountType_pcs: "Darab",
  amountType_hourly: "Óra",
  appellation: "Megnevezés",
  app_currency: "Ft",
  attachment: "Csatolmány",
  attachments: "Csatolmányok",
  at_rental: "bérléskor",
  at_returnal: "visszavételkor",
  available_count: "Elérhető",
  back: "Vissza",
  bank: "Bank",
  bankAccount: "Bankszámlaszám",
  calendar_events: "Naptár események",
  cancel: "Mégsem",
  cant_be_greater_than_rented_value: "Nem lehet nagyobb mint a bérlésnél megadott érték!",
  cant_be_less_than_rented_value: "Nem lehet kisebb mint a bérlésnél megadott érték!",
  cant_be_empty: "Nem lehet üres!",
  field_cant_be_empty: (field: string) => `A(z) ${field} nem lehet üres!`,
  category: "Kategória",
  caution: "Kaució",
  checklist: "Ellenőrzési lista",
  checklist_alerts: "Eszköz ellenőrzés riasztások",
  checklist_rental: "Bérlési ellenőrzések",
  checklist_returnal: "Visszavételi ellenőrzések",
  checklist_required: "Ellenőrzési lista kötelező",
  checklist_send: "Kiküldés",
  checklist_show_accepted: "Elfogadott listák megtekintése",
  checklist_sent_out: "Kiküldve",
  checklist_accepted_at: "Elfogadva",
  checklist_send_success: "Ellenőrzési lista sikeresen kiküldve",
  checklist_show_rental: "Bérlési ellenőrzés listák",
  checklist_show_returnal: "Visszavételi ellenőrzés listák",
  checklist_ratio: "Összes / kitöltött",
  checklist_start: "Kezdete",
  checklist_end: "Vége",
  checklist_state: "Ellenőrzési lista",
  checklists: "Ellenőrzési listák",
  checklist_state_accepted: "Elfogadva",
  checklist_state_ignored: "Figyelmen kívül hagyva",
  checklist_state_sent_out: "Kiküldve",
  checklist_state_ready: "Nincs kiküldve",
  checklist_state_missing_attachments: "Képfeltöltésre vár",
  checklist_state_missing: "Kitöltésre vár",
  checklist_state_not_required: "Nem kötelező",
  checklist_ignore: "Figyelmen kívül hagyás",
  checklist_ignore_tooltip: "A figyelmen kívül hagyással a korábban létrehozott lista és a feltöltött képek törlődnek",
  checklist_ignore_revert: "Visszaállítás",
  checklist_ignore_revert_tooltip: "A visszaállítással az ellenőrzési lista kitöltése kötelezővé válik",
  checklist_ignore_confirm: "Biztosan figyelmen kívül hagyod az ellenőrzési listát?",
  checklist_ignore_revert_confirm: "Biztosan újra kötelezővé teszed az ellenőrzési listát?",
  checklist_ignore_success: "Az ellenőrzési lista figyelmen kívül hagyva",
  checklist_ignore_revert_success: "Az ellenőrzsi lista kitöltése kötelező",
  checklist_send_out: "Ellenőrzési listák kiküldése",
  checklist_recipients: "Címzettek",
  checklist_option_true: "IGEN",
  checklist_option_false: "NEM",
  checklist_option_not_applicable: "NEM ÉRTELMEZETT",
  checklist_send_confirm: "Biztos, hogy kiküldöd az ellenőrzési listákat?",
  checklistPropertyOperatingHours: "Üzemóra",
  checklistPropertyHydraulicOil: "Hidraulika olajszint (ellenőrző nyílás) rendben",
  checklistPropertyHydraulicSystem: "Hidraulika rendszer (henger dugattyúrúdjai, tömlők, szürők, csatlakozások) rendben",
  checklistPropertyElectronicSystem: "Elektromos berendezések (kapcsolók, vezetékek, csatlakozások) rendben",
  checklistPropertyGauges: "Mérőműszerek, kürt, hátrameneti hangjelző, akkumlátor",
  checklistPropertyLights: "Irányjelzők, vészjelző lámpák, ablaktörlő motor, fülkekapcsoló, lámpák",
  checklistPropertyEngine: "Motor (olajszint, hűtőrendszer, üzemanyag ellátás, levegőszürő) rendben",
  checklistPropertyBody: "Karosszéria, vázszerkezet, gémszerkezet, csuklópontok rendben",
  checklistPropertyDrive: "Hajtómű (kerékagy rögzítőcsavarok, kerékanyák, csillagkerék, görgők, feszítőkerék) rendben",
  checklistPropertySafety: "Biztonsági berendezések (öv, védőkeret) rendben",
  checklistPropertyWheels: "Kerekek/lánctalp ellenőrzése (állapot, csavarok) rendben",
  checklistPropertyBrakes: "Fékek müködése rendben",
  checklistPropertyGreasing: "Kenési pontok (zsírzás) rendben",
  checklistPropertyDashboard: "Műszerfal, kapcsolók, vezetékek, csatlakozások rendben",
  checklistPropertyWindows: "Üvegek állapota rendben",
  checklistPropertyParticleFilter: "DPF, ADBLUE rendszer rendben",
  checklistPropertyErrorCodes: "Hibakódmentes a gép",
  checklistPropertyAdapters: "Kiadott adapterek rendben",
  checklistPropertyHeating: "Fűtés és klíma rendben",
  checklistPropertyFuel: "Üzemanyag mennyiség",
  checklistPropertyCleanliness: "Eszköz tisztasága rendben (10.000 Ft/óra+Áfa)",
  checklistPropertyFireExtinguisher: "Tűzoltó készülék (nettó 13.000 Ft)",
  checklistPropertyManual: "Kezelési utasítás, gépnapló (10.000 Ft + 2000 Ft)",
  checklistPropertyHandGreaser: "Kézi zsírzó (9000 Ft) rendben, kiadott zsír mennyisége",
  checklistPropertyKey: "Kulcs (10.000 Ft+Áfa) rendben",
  checklistPropertyChangerKey: "Gyorscserélő kulcs rendben",
  checklistPropertyReportAfterReturnal: "Visszavétel után hibafelvételi lap készül",
  checklistPropertyWorksheetAfterReturnal: "Visszavétel után munkalap készül",

  document_sendout_documents: "Kiküldött dokumentumok",
  document_recipients: "Címzettek",
  document_send_subtitle: "Dokumentumok kiküldése",
  document_send_out: "Kiküldve",
  document_send: "Kiküldés",
  documents: "Dokumentumok",
  documents_send_success: "Dokumentumok sikeresen kiküldve",
  document_type_transport_letter: "Szállítólevél",
  document_type_deposit_request: "Kaució bekérő",
  document_type_terms: "ÁSZF",
  document_type_maintenance: "Karbantartási útmutató",
  document_type_rental_contract: "Bérleti szerződés",
  document_type_returnal_contract: "Visszavételi jegyzőkönyv",
  document_sendout_types: "Kiküldött dokumentum típusok",
  document_no_sendouts: "Még nincsenek kiküldött dokumentumok",
  document_upload: "Dokumentum feltöltés",
  document_send_confirm: "Biztos, hogy kiküldöd a dokumentumokat?",
  rental_checklist_missing: "Ehhez a tételhez nincs bérleti ellenőrzési lista",
  choose: "Válassz",
  city: "Település",
  client: "Ügyfél",
  client_contacts: "Kontaktok",
  client_contact: "Kontakt",
  client_create: "Ügyfél hozzáadása",
  client_details: "Ügyfél adatok",
  client_invoices: "Ügyfél számlái",
  client_name: "Ügyfél neve",
  client_representative: "Cég képviseletében",
  client_responsible: "Felelős személy, átvevő",
  client_site: "Munkavégzés helye",
  client_sites: "Munkavégzési helyek",
  clients: "Ügyfelek",
  contact: "Kapcsolat",
  contact_name: "Kapcsolattartó neve",
  contact_phone: "Kapcsolattartó tel.",
  contact_selector_no_email: "Nincs email címmel rendelkező kontakt!",
  contact_selector_missing_email: "Nem minden választott címzett rendelkezik email címmel!",
  contact_selector_invalid_email: "Nem minden választott címzett emailcímformátuma érvényes!",
  content: "Tartalom",
  comment: "Megjegyzés",
  comment_other: "Egyéb megjegyzés",
  company: "cég",
  company_name: "Cégnév",
  completion_date: "Teljesítés dátuma",
  continuous_fulfillment_date_error: 'A Teljesítés dátuma es a Fizetési határidő meg kell egyezzen',
  copy_link: "Link másolása",
  copied_to_clipboard: "Vágólapra másolva",
  cost_bearer: "Költségviselő",
  cost_renter: "Ügyfél költsége",
  cost_renter_short: "Ügyfél",
  cost_own: "Saját költség",
  cost_own_short: "Saját",
  date: "Dátum",
  day: "nap",
  day_monday: "Hétfő",
  day_tuesday: "Kedd",
  day_wednesday: "Szerda",
  day_thursday: "Csütörtök",
  day_friday: "Péntek",
  day_saturday: "Szombat",
  day_sunday: "Vasárnap",
  delete: "Törlés",
  undelete: "Visszaállítás",
  delete_date: "Törlés dátuma",
  delete_reason: "Törlés oka",
  deleted: "Törölve",
  delete_confirm: "Biztos, hogy törlöd az adott tételt?",
  undelete_confirm: "Biztos, hogy visszaállítod a törölt tételt?",
  delete_confirm_multiple: "Biztos hogy törlöd az adott tételeket?",
  delete_success: "Sikeres törlés",
  detach: "Leválasztás",
  download: "Letöltés",
  discount: "Kedvezmény",
  distance: "Táv",
  driver_name: "Gépjárművezető neve",
  edit: "Szerkesztés",
  edit_contact: "Kontakt szerkesztése",
  edit_entry: "Tétel szerkesztése",
  email: "Email",
  email_invalid: "Nem megfelelő E-mail cím",
  email_send_result_checklist: "Ellenőrzési lista kiküldés",
  email_send_result_document: "Dokumentum kiküldés",
  email_send_result_success: "Sikeres kiküldések",
  email_send_result_failure: "Sikertelen kiküldések",
  end_address: "Úticél",
  entry: "tétel",
  entry_mandatory: "Kötelező tételt megadni!",
  entries: "Tételek",
  entry_name: "Tétel neve",
  entry_comment: "Tétel megjegyzés",
  error: "Hiba",
  error403: "Nincs jogosultságod az oldal megtekintéséhez!",
  error404: "Az oldal nem található!",
  error_description: "Hibajelenség",
  error_whitespace: "Szóköz használata nem megengedett!",
  event_calendar: "Naptár",
  event_create: "Esemény hozzáadása",
  event_completed: "Teljesült",
  event_not_completed: "Nem teljesült",
  event_delete_confirm: "Biztos, hogy törlöd ezt az eseményt?",
  event_date: "Dátum",
  event_details: "Esemény részletei",
  event_location: "Helyszín",
  event_show_next_week: "Következő hét",
  event_show_previous_week: "Előző hét",
  event_sales_user: "Értékesítő",
  event_subject: "Tárgy",
  event_time_range_start: "Kezdete",
  event_time_range_end: "Vége",
  event_alert_time: "Emlékeztető",
  event_time_range_error: "A minimális esemény időtartam 15 perc",
  event_type_online: "Online találkozó",
  event_type_personal: "Személyes találkozó",
  event_type_todo: "Teendő",
  event_type: "Esemény típusa",
  event_alerts: "Esemény emlékeztetők",
  event_show_todos: "Teendők mutatása",
  event_delete_alert: "Biztos, hogy törlöd az eseményhez tartozó emlékeztetőt?",
  event_show_alert: "Emlékeztető",
  event_alert_date: "Emlékeztető időpontja",
  event_alert_date_error: "Az emlékeztető időpontja nem lehet később mint az esemény kedzete",
  event_alert_handle: "Biztos, hogy lekezeled az adott emlékeztetőt?",
  event_alert_state: "Emlékeztető állapota",
  event_alert_state_new: "Új",
  event_alert_state_triggered: "Lejárt",
  event_alert_state_handled: "Lekezelt",
  delivery_method: "Átvétel módja",
  delivery_method_courier: "Futár",
  delivery_method_personal: "Személyes átvétel",
  transport_cost_huf: "Szállítási költség",
  invoice_comment: "Számlamegjegyzés",
  sale_invoice_comment_tooltip: "Ez a megjegyzés csak a számlán jelenik meg.",
  invoice_state_sent: "Beküldve",
  invoice_state_created: "Létrehozva",
  invoice_state_cancelled: "Sztornózva",
  invoice_state_deleted: "Törölve",
  invoice_open: "Megnézem",
  invoice_type_proforma: "Díjbekérő",
  invoice_type_prepayment: "Előlegszámla",
  invoice_type_invoice: "Számla",
  invoice_type_final: "Végszámla",
  invoice_type_storno: "Sztornó",
  invoice_type_corrective: "Helyesbítő számla",
  invoice_delete_confirm: "Biztos, hogy törlöd ezt a számlát?",
  excel_export: "Excel exportálás",
  export_to_be_transferred_items: "Utalási lista exportálása",
  fax: "Fax",
  fees: "Árak",
  fee_per_km: "Díj / km",
  file_name: "Fájlnév",
  file_upload_success: "Sikeres fájl feltöltés",
  file_delete_confirm: "Biztos, hogy törlöd a fájlt?",
  file_delete_success: "Sikeres fájl törlés",
  file_upload_message: "Kattints vagy húzz egy fájlt erre a területre a feltöltéshez",
  filter_by_issue_date: "Kiállítás dátuma szerinti szűrés",
  file_upload: "Feltöltés",
  finalize: "Lezárás",
  finalized: "Lezárva",
  finalized_revert: "Lezárás visszavonása",
  finalize_confirm: "Biztos, hogy lezárod a kijelölt tételeket?",
  revert_finalize_confirm: "Biztos, hogy visszanyitod a tételt?",
  finalize_maintenance: "Biztos, hogy lezárod a munkalapot?",
  footerCopyRight: (year: number) => `Copyright © ${year} RENTime Kft.`,
  future_date: "jövőbeni",
  from: "Mettől",
  fuel_empty: 'Üres',
  fuel_quarter: 'Negyed',
  fuel_half: 'Fél',
  fuel_three_quarter: '3/4',
  fuel_full: 'Tele',
  gross_price: "Bruttó ár",
  handle: "Lekezelés",
  handle_item_confirm: "Biztos, hogy lekezeled az adott tételt?",
  handle_item_revert: "Biztos, hogy visszavonod a tétel lekezelését?",
  handle_item_maintenance_close: "Biztos, hogy lekezeled az adott szervíz munkalapot?",
  handle_item_maintenance_reopen: "Biztos, hogy visszanyitod az adott szervíz munkalapot?",
  handled: "Lekezelt",
  handle_confirm: "Biztos, hogy lekezeled a kijelölt tételeket?",
  has: "Van",
  hasNot: "Nincs",
  hours: "óra",
  iban: "IBAN",
  id: "Azonosító",
  id_number: "Személyi igazolvány",
  images: "Képek",
  images_front_left: "Bal első",
  images_rear_left: "Bal hátsó",
  images_front_right: "Jobb első",
  images_rear_right: "Jobb hátsó",
  images_interior: "Belső",
  images_other: "Egyéb",
  income: "Árbevétel",
  incoming_invoices: "Bejövő számlák",
  incoming_invoice: "Bejövő számla",
  incoming_invoice_add: "Bejövő számla hozzáadása",
  incoming_invoice_details: "Bejövő számla részletei",
  incoming_invoice_item_detach_confirm: "Biztos, hogy leválasztod az adott eszközt a bejövő számláról?",
  inventory: "Raktárazás",
  inventory_stocks: "Raktárkészlet",
  inventory_stock_create: "Készlettétel hozzáadása",
  inventory_stock_edit: "Készlettétel szerkesztése",
  inventory_stock_details: "Készlettétel adatai",
  inventory_stock_item_add: "Darabok hozzáadása",
  inventory_stock_item_source: "Bevételezés alapja",
  inventory_stock_item_delete_confirm: "Biztosan törlöd a kiválasztott készlet darabokat?",
  inventory_stock_items: "Készlettétel darabok",
  inventory_stock_selected_count: (count: number) => `Összesen ${count} tétel kiválasztva.`,
  select_incoming_invoice: "Bejövő számla kiválasztása",
  selected_incoming_invoice: "Kiválasztott bejövő számla",
  selected_item: "Kiválasztott eszköz",
  count: "Darabszám",
  profit_margin_percent: "Haszonkulcs %",
  selling_price: "Eladási ár",
  infinite_stock: "Többször kiadható",
  internally_used: "Belső használat",
  internal_usage_cost: "Belsőleg felhasznált készletdarabok költsége",
  internally_used_add: "Létrehozás belső használatra",
  internally_used_inventory_items: "Belső használatú készlettételek",
  initial_cost: "Bekerülési érték",
  initiate_call: "Hívás kezdeményezés",
  invalid_session: "Érvénytelen munkamenet",
  invalid_role: "Nincs jogosultságod a művelet elvégzéséhez!",
  invalid_input: "Érvénytelen bemenet!",
  inventoryNumber: "Leltári szám",
  invoice: "Számla",
  open_invoice: "Nyitott számla",
  invoice_create: "Számla létrehozása",
  invoice_confirm: "Biztos, hogy létrehozod a számlát?",
  invoice_data: "Számlázási adatok",
  invoice_number: "Számla sorszáma",
  invoice_history: "Számlatörténet",
  invoice_send: "Küldés szamlazz.hu-ra",
  invoice_send_confirm: "Biztos, hogy elküldöd a számlát a szamlazz.hu-ra?",
  invoice_storno: "Számla sztornózása",
  invoice_view: "Számla megtekintése",
  invoices: "Számlák",
  invoicing: "Számlázás",
  invoicing_suffix: "Megnevezés utótag",
  invoicing_suffix_default: "bérlése",
  issue_date: "Kiállítás dátuma",
  item: "Eszköz",
  item_add: "Eszköz hozzáadása",
  item_categories: "Eszköz kategóriák",
  item_deletion: "Eszköz törlés",
  item_delete_confirm: "Biztos, hogy törlöd az eszközt?",
  item_details: "Eszköz adatai",
  item_in_maintenance: "Szervízben van",
  item_mandatory: "Kötelező eszközt hozzáadni!",
  item_number: "Cikkszám",
  item_registration: "Eszköz regisztráció",
  item_value: "Bérleti gépérték",
  item_acquisition_value: "Bekerülési érték",
  item_acquisition_value_huf: "Bekerülési érték (Ft)",
  item_exchange_rate_refresh_tooltip: "Frissíti az EUR árfolyamot a mai dátum szerinti MNB középárfolyam alapján.",
  item_external: "Külső eszköz",
  item_external_owner: "Külső eszköz tulajdonosa",
  items: "Eszközök",
  itemType_device: 'Eszköz',
  itemType_service: 'Szolgáltatás',
  km_reading: "Km állás",
  licensePlate: "Rendszám",
  logged_out: "Ki lettél jelentkeztetve!",
  login: "Bejelentkezés",
  state_filter: "Állapot szűrő",
  logout: "kijelentkezés",
  logout_confirm: "Biztos hogy ki akarsz jelentkezni?",
  mandatory: "Kötelező megadni!",
  message: "Üzenet",
  move: "Mozgatás",
  move_items_confirm: "Biztosan mozgatod a kijelölt készlet darabokat?",
  move_invalid_target: "Érvénytelen célpont a mozgatáshoz!",
  maintenance: "Szervíz",
  maintenance_installed: "Beszerelt",
  maintenance_worksheet: "Szervíz munkalap",
  maintenance_worksheets: "Szervíz munkalapok",
  maintenance_sheet: "Szervíz adatlap",
  maintenance_history: "Szervíztörténet",
  maintenance_history_entry_group_info: "Különböző árú darabok",
  maintenance_history_view: "Szervíz adatlap megtekintése",
  maintenance_date: "Szervíz dátuma",
  manual: "Manuális",
  mark_to_be_transferred: "Utalási listára mozgatás",
  mark_transferred: "Utalási lista lezárása",
  material_usage: "Anyagfelhasználás",
  mm: "mm",
  month: "hónap",
  month_capitalized: "Hónap",
  mothers_name: "Anyja neve",
  name: "Név",
  net_price: "Nettó ár",
  net_unit_price: "Nettó egységár",
  net_unit_price_non_zero: "A nettó egységár nem lehet 0!",
  no: "Nem",
  no_images_uploaded: "Nincsenek feltöltött képek",
  not_handled: "Nem lekezelt",
  not_used: "Nem használt",
  ok: "Ok",
  on_rental_form: "Bérletin",
  open_map: "Térkép megnyitása",
  operationHours: "Üzemóra",
  operation_hours_reading: "Üzemóra állás",
  otherData: "Egyéb adatok",
  overall: "Összesített",
  override_values: "Értékek felülírása",
  override_delete: "Felülírás törlése",
  overridden: "Felülírva",
  override_values_for_given_month: "Értékek felülírása (adott hónapra érvényes)",
  overdue: "Lejárt",
  unit_price: "Egységár",
  paid: "Fizetve",
  password: "Jelszó",
  password_again: "Jelszó újra",
  password_not_match: "A beírt jelszavak nem egyeznek!",
  password_missing: "Add meg a jelszavad",
  password_confirm_missing: "Add meg újra a jelszót!",
  payment_fulfillment: "Teljesítés",
  payment_created: "Keltezés",
  payment_deadline: "Fizetési határidő",
  paymentType: "Fizetés módja",
  paymentType_cash: "Készpénz",
  paymentType_transfer: "Átutalás",
  pcs: "db",
  price_daily: "Napi ár",
  price_hourly: "Óránkénti ár",
  price_monthly: "Havi ár",
  price_mm: "Kopás mm ár",
  price_pcs: "Darab ár",
  print: "Nyomtatás",
  privatePerson: "magányszemély",
  profit: "Profit",
  properties: "Tulajdonságok",
  range: "Tartomány",
  regNumber: "Cégjegyzékszám",
  release_notes: "kiadási megjegyzések",
  reminder: "Emlékeztető",
  reminders: "Emlékeztetők",
  reminders_remaining: "Vannak teljesítetlen emlékeztetők",
  reminders_all_checked: "Minden emlékeztető teljesítve",
  rental: "Bérlés",
  rental_other_comment: "Bérléshez tartozó megjegyzés",
  returnal_other_comment: "Visszavételhez tartozó megjegyzés",
  rental_client: "Bérbevevő",
  rental_created: "Kiadás",
  rental_create: "Bérleti létrehozása",
  rental_date: "Bérleti időpontja",
  rental_details: "Bérlés adatai",
  rental_form: "Bérleti szerződés",
  rentals: "Bérlések",
  source: "Forrás",
  reopen: "Visszanyitás",
  reopen_confirm: "Biztos, hogy visszanyitod a tételt?",
  resource: "Erőforrás",
  return: "Visszavétel",
  return_create: "Visszavételi létrehozása",
  return_date: "Visszavétel időpontja",
  return_details: "Visszavétel adatai",
  returns: "Visszavételek",
  returnal_form: "Visszavételi jegyzőkönyv",
  revert: "Visszaállítás",
  save: "Mentés",
  save_and_print: "Mentés és nyomtatás",
  save_confirm: "Biztos, hogy mented a változtatásokat?",
  save_error: "Mentés sikertelen",
  save_success: "Sikeres mentés",
  search: "Keresés",
  search_term: "Keresési feltétel",
  select_item: "Eszköz választás",
  send_email: "Email küldés",
  serial: "Szériaszám",
  repair: "Javítás",
  repair_time: "Munkaidő",
  repair_cost_per_hour: "Díj / óra",
  responsible_user: "Felelős felhasználó",
  set_transferred_date: "Biztos, hogy megjelölöd a kiválasztott tételeket átutaltként?",
  settled_amount: "Elszámolt mennyiség",
  settlement: "Elszámolás",
  site_missing: "Nincs megadva munkavégzési hely",
  sheet: "Adatlap",
  show_all_item: "Összes eszköz",
  show_only_deleted: "Csak töröltek mutatása",
  show_with_maintenance_sheet: "Szervíz adatlappal rendelkezők",
  show_without_maintenance_sheet: "Szervíz adatlap nélküliek",
  sum: "Összeg",
  currency: "Pénznem",
  currency_huf: "Ft",
  currency_eur: "Eur",
  exchange_rate: "Árfolyam",
  exchange_rate_refresh_tooltip: "Frissíti az EUR árfolyamot a teljesítés dátuma szerinti MNB középárfolyam alapján.",
  exchange_rate_refresh_error: "Az árfolyam frissítése sikertelen.",
  huf_sum: "Összeg (Ft)",
  sale: "Eladás",
  sales: "Eladások",
  sales_details: "Eladás részletei",
  sales_create: "Eladás létrehozása",
  sale_delete_confirm: "Biztosan törölni szeretnéd az eladást?",
  sale_edit_delete_requires_no_invoice: "Az eladás csak akkor szerkeszthető vagy törölhető, ha nem tartozik hozzá számla.",
  sold: "Eladva",
  start_address: "Indulás",
  start_address_default: "1097 Budapest, Kén utca 1.",
  state: "Állapot",
  state_rented: "Kiadva",
  state_available: "Elérhető",
  state_returned: "Visszahozva",
  state_pending: "Függőben",
  state_open: "Nyitott",
  state_to_be_transferred: "Utalandó",
  state_transferred: "Kifizetett",
  statistics: "Statisztikák",
  statistics_no_data: "A választott tartományban nincs rögzített adat.",
  storno: "Sztornó",
  storno_confirm: "Biztos, hogy sztorzózod a tételeket?",
  street_house_number: "Utca, házszám",
  brand: "Márka",
  summary: "Bérlési összesítő",
  revenue_summary: "Bevételi összesítő",
  revenue_totals: "Bevételek összesen",
  total_revenue: "Bevételi tételek száma",
  finalized_revenue: "Lezárt bevételi tételek száma",
  uninvoiced_revenue: "Nem számlázott bevételi tételek száma",
  summaries: "Bérlési összesítők",
  taxNumber: "Adószám",
  tel: "Telefonszám",
  tel_short: "tel.:",
  title: "Titulus",
  to: "Meddig",
  today: "Ma",
  total: "Összesen",
  invoiced_total: "Számlázott",
  all_time_outstanding: "Kintlévőségek (teljes időszak)",
  outstanding_total: "Kintlévőség",
  total_count: "Összes",
  total_cost: "Összes költség",
  total_income: "Teljes bevétel",
  total_rental_income: "Teljes bérleti bevétel",
  total_maintenance_income: "Teljes szervíz bevétel",
  total_maintenance_cost: "Teljes szervíz költség",
  type: "Típus",
  transport_company_name: "Szállító cég neve",
  transport_cost: "Szállítási költség",
  transport_form: "Szállítólevél",
  transport_letters: "Szállítólevelek",
  transport_letter: "Szállítólevél",
  transport_letter_select: "Szállítólevél kiválasztása",
  transport_letter_add: "Szállítólevél hozzáadása",
  transport_letter_details: "Szállítólevél részletei",
  transport_letter_save_success_with_updated_invoices: (count: number) =>`Szállítólevél mentése sikeres. A szállítólevélhez tartozó ${count} készlettétel darab számlája frissült.`,
  travel: "Kiszállás",
  unfinalized: "Lezáratlan",
  url: "URL",
  usage: "Kihasználtság",
  usage_statistics_notes: "Többször kiadható és kopás mm-es eszközöknél nem értelmezett a kihasználtság statisztika.",
  username: "Felhasználónév",
  username_missing: "Add meg a felhasználóneved",
  user_management: "Felhasználókezelés",
  user: "Felhasználó",
  user_add: "Új felhasználó",
  user_edit: "Felhasználó szerkesztése",
  user_create: "Felhasználó hozzáadása",
  user_role: "Jogosultság",
  user_admin: "Admin",
  user_sales: "Értékesítő",
  user_maintenance: "Szervízes",
  user_enabled: "Elérhető",
  user_disabled_users: "Inaktív felhasználók",
  warehouse: "Raktár",
  warehouses: "Raktárak",
  created_at: "Létrehozva",
  created_by: "Létrehozta",
  last_changed_at: "Utoljára módosítva",
  last_changed_by: "Utoljára módosította",
  default_tag: "Alapértelmezett",
  warehouse_create: "Raktár hozzáadása",
  warehouse_edit: "Raktár szerkesztése",
  warehouse_default: "Alapértelmezett",
  vat: "ÁFA",
  version: "verzió",
  view_rental: "Bérleti megtekintése",
  view_returnal: "Visszavételi megtekintése",
  where_applicable: "ahol értelmezett",
  warning: "Figyelmeztetés",
  work_description: "Elvégzett munka",
  work_location: "Munkavégzés helye",
  worker_names: "Munkavégző(k) neve",
  yes: "Igen",
  zip: "Irányítószám",
  invoiceInitialCommentTemplate: (monthStart: string, monthEnd: string) => `Bérleti időszak: ${monthStart} - ${monthEnd}
A számla továbbszámlázott szolgáltatást tartalmaz.
Köszönjük, hogy igénybe vette a szolgáltatásunkat!`,
};

export default locales;



// WEBPACK FOOTER //
// ./src/locales.ts